import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="invite-to-stream"
export default class extends Controller {
  static values = {
    liveEventInputUrl: String
  }

  static targets = ["communitySpaceSelect"]

  connect() {
    this.boundHandleCommunitySpaceChange = this.handleCommunitySpaceChange.bind(this)
    this.communitySpaceSelectTarget.addEventListener("change", this.boundHandleCommunitySpaceChange)
  }

  disconnect() {
    if (this.hasCommunitySpaceSelectTarget) {
      this.communitySpaceSelectTarget.removeEventListener("change", this.boundHandleCommunitySpaceChange)
    }
  }

  handleCommunitySpaceChange(event) {
    const url = `${this.liveEventInputUrlValue}?community_space_id=${event.target.value}`
    Turbo.visit(url, { frame: "live_event_input" })
  }
}
